// extracted by mini-css-extract-plugin
export default {"modal":"HelpDesk_modal__7G8D9","headingYellow":"HelpDesk_headingYellow__7kROk","text":"HelpDesk_text__AF9Yq"};